"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = _interopRequireDefault(require("./image"));
var _outOfViewportSpaceHolder = _interopRequireDefault(require("./out-of-viewport-space-holder"));
var _viewportChecker = _interopRequireDefault(require("../viewport-checker"));
var _excluded = ["height", "imageOnlyClassName", "imageWhenHiddenClassName", "includeFallback", "lazyLoad", "placeholder", "width", "wrapInFlex"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DEFAULT_X_THRESHOLD = 300;
var DEFAULT_Y_THRESHOLD = 500;

/**
 * An all-purpose image component. Provides "lazy-loading", graceful image fade-in, and flexible sizing. Most of its functionality can be toggled off or worked around via its many props.
 *
 * **To see many of ImageLoader's performance functionality (such as lazy loading and graceful fade-in) you may need to enable network throttling or hard-refresh the browser so the cached images are cleared.**
 */

var ImageLoader = function ImageLoader(_ref) {
  var height = _ref.height,
    imageOnlyClassName = _ref.imageOnlyClassName,
    imageWhenHiddenClassName = _ref.imageWhenHiddenClassName,
    includeFallback = _ref.includeFallback,
    lazyLoad = _ref.lazyLoad,
    placeholder = _ref.placeholder,
    width = _ref.width,
    wrapInFlex = _ref.wrapInFlex,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // This component takes several objects as props. Since there is no React-way to define
  // default values for nested object properties without risk of override if the
  // consumer provides an object that does not include the property with the default value,
  // we define defaults here, and then spread object properties.
  // tl;dr - placeholder, wrapInFlex, lazyLoad, and includeFallback defaults defined below.
  var includeFallbackProps = _objectSpread({
    enabled: false,
    wrapperClassName: '',
    fallbackClassName: ''
  }, includeFallback);
  var lazyLoadProps = _objectSpread({
    enabled: true
  }, lazyLoad);
  var placeholderProps = _objectSpread({
    alt: ''
  }, placeholder);
  var wrapInFlexProps = _objectSpread({
    enabled: false
  }, wrapInFlex);
  // ---- end default values!

  var lazyLoadEnabled = lazyLoadProps.enabled,
    xThreshold = lazyLoadProps.xThreshold,
    yThreshold = lazyLoadProps.yThreshold;
  var constrainWidth = wrapInFlexProps.constrainWidth,
    wrapInFlexEnabled = wrapInFlexProps.enabled,
    flexEmbedWrapperClassName = wrapInFlexProps.flexEmbedWrapperClassName,
    flexHeight = wrapInFlexProps.height,
    flexWidth = wrapInFlexProps.width;
  var includeFallbackEnabled = includeFallbackProps.enabled,
    fallbackClassName = includeFallbackProps.fallbackClassName,
    wrapperClassName = includeFallbackProps.wrapperClassName,
    onLoad = includeFallbackProps.onLoad,
    onError = includeFallbackProps.onError;
  var constrainStyle = constrainWidth ? {
    maxWidth: flexWidth || width
  } : null;
  var imageComponentProps = _objectSpread({
    constrainStyle: constrainStyle,
    fallbackClassName: fallbackClassName,
    flexEmbedWrapperClassName: flexEmbedWrapperClassName,
    flexHeight: flexHeight,
    flexWidth: flexWidth,
    height: height,
    imageOnlyClassName: imageOnlyClassName,
    imageWhenHiddenClassName: imageWhenHiddenClassName,
    includeFallbackEnabled: includeFallbackEnabled,
    onError: onError,
    onLoad: onLoad,
    placeholderProps: placeholderProps,
    width: width,
    wrapInFlexEnabled: wrapInFlexEnabled,
    wrapperClassName: wrapperClassName
  }, otherProps);
  return lazyLoadEnabled ? /*#__PURE__*/_react["default"].createElement(_viewportChecker["default"], {
    unobserveOnIntersection: true,
    xThreshold: typeof xThreshold === 'number' ? xThreshold : DEFAULT_X_THRESHOLD,
    yThreshold: typeof yThreshold === 'number' ? yThreshold : DEFAULT_Y_THRESHOLD
  }, function (_ref2) {
    var isIntersecting = _ref2.isIntersecting,
      elementRef = _ref2.elementRef;
    return isIntersecting ? /*#__PURE__*/_react["default"].createElement(_image["default"], _extends({}, imageComponentProps, {
      ref: elementRef
    })) : /*#__PURE__*/_react["default"].createElement(_outOfViewportSpaceHolder["default"], {
      constrainStyle: constrainStyle,
      flexEmbedWrapperClassName: flexEmbedWrapperClassName,
      flexHeight: flexHeight,
      flexWidth: flexWidth,
      height: height,
      placeholder: placeholderProps,
      ref: elementRef,
      width: width
    });
  }) : /*#__PURE__*/_react["default"].createElement(_image["default"], imageComponentProps);
};
ImageLoader.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Required if image conveys information to the user.
   */
  alt: _propTypes["default"].string,
  /**
   * Set as an attribute on the rendered `<img />` tag. Note, since this may be ignored due to height:auto
   * being set in our pattern library global css, a maxHeight style property will also be generated.
   */
  height: _propTypes["default"].string,
  /**
   * Role should be set to 'presentation' if image does not convey useful information to the user;
   * do not pass a role if the image is not presenational/decorative.
   */
  role: _propTypes["default"].string,
  /**
   * Image source
   */
  src: _propTypes["default"].string,
  /**
   * Set as an attribute on the rendered `<img />` tag
   */
  width: _propTypes["default"].string,
  /** Set to true for images that are known to be smaller than the parent column.
   * Used to hold space with a set width and height div before image has come into viewport.
   */
  constrainWidth: _propTypes["default"].bool,
  /**
   * Applied to the image itself. If `includeFallback` is enabled, also applies to the fallback.
   */
  className: _propTypes["default"].string,
  /**
   * Styles the image only when visible.
   */
  imageOnlyClassName: _propTypes["default"].string,
  /**
   * Styles the image only when hidden (either loading or behind fallback if `includeFallback` is enabled)
   */
  imageWhenHiddenClassName: _propTypes["default"].string,
  lazyLoad: _propTypes["default"].shape({
    /** True by default. Wraps image in ViewportChecker. If the image lives "above the fold" and never should check the viewport, but should load automatically, set to false.
     * See [ViewportChecker documentation](/components/misc/#viewport-checker) for more information.
     */
    enabled: _propTypes["default"].bool,
    /**
     * Pixel value threshold for triggering `hasBeenInViewport` on x-axis.
     * Set to 300 pixels by default.
     * If you set this value, make sure lazyLoad.enabled is set to true.
     * See ViewportChecker for more information.
     */
    xThreshold: _propTypes["default"].number,
    /**
     * Pixel value threshold for triggering `hasBeenInViewport` on y-axis.
     * Set to 500 pixels by default.
     * If you set this value, make sure lazyLoad.enabled is set to true.
     * See ViewportChecker for more information.
     */
    yThreshold: _propTypes["default"].number
  }),
  /**
   * Props for an optional placeholder image to be used while true image loads.
   * While `lazyLoad.enabled` is true, it saves space for the image as it comes into viewport.
   * If `includeFallback.enabled` is true, image will fade in from the placeholder instead of the
   * grey fallback div.
   */
  placeholder: _propTypes["default"].shape({
    /**
     * Provide an alt for the placeholder if it conveys meaningful information to users
     */
    alt: _propTypes["default"].string,
    /**
     * src attribute for the placeholder image
     */
    src: _propTypes["default"].string
  }),
  wrapInFlex: _propTypes["default"].shape({
    /**
     * Wrap the image in a FlexEmbed component to prevent the page from jumping around as it renders.
     * Defaults to a 1:1 ratio unless you provide flexHeight and flexWidth to create
     * a custom ratio.
     * See the [FlexEmbed documentation](/components/images/#flex-embed) for more information.
     */
    enabled: _propTypes["default"].bool,
    /**
     * For images that are known to be smaller than the parent column,
     * set to true to create a max-width for FlexEmbed parent.
     */
    constrainWidth: _propTypes["default"].bool,
    /**
     * Passed through to underlying FlexEmbed components. In combination with width, this provides
     * a ratio to preserve the right amount of flexible space for the image in the layout.
     * See the [FlexEmbed documentation](/components/images/#flex-embed) for more information.
     */
    height: _propTypes["default"].number,
    /**
     * Passed through to underlying FlexEmbed components. In combination with height, this provides
     * a ratio to preserve the right amount of flexible space for the image in the layout.
     * See [FlexEmbed documentation](/components/images/#flex-embed) for more information.
     */
    width: _propTypes["default"].number,
    /**
     * If `wrapInFlex.enabled` is set to true, use this className to style the grandest-parent of the image.
     * See FlexEmbed for more information on how to style.
     */
    flexEmbedWrapperClassName: _propTypes["default"].string
  }),
  includeFallback: _propTypes["default"].shape({
    /**
     * Wraps the image in a relatively positioned div, and absolutely positions the image with its fallback (grey div or `placeholder`).
     */
    enabled: _propTypes["default"].bool,
    /**
     * Class applied to fallback div or placeholder image.
     */
    fallbackClassName: _propTypes["default"].string,
    /**
     * Applied to the div surrounding the image and its fallback. This wrapper is automatically positioned relatively, so that the absolute image and fallback can travel together.
     */
    wrapperClassName: _propTypes["default"].string
  })
} : {};
ImageLoader.displayName = 'ImageLoader';
var _default = exports["default"] = ImageLoader;